module.exports = __webpack_public_path__ + "img/eSignsLogoBlack.8d72467a.svg";